module.exports = __webpack_public_path__ + "img/Wechat.93e5798f.png";